import React from "react";
import Select from "react-select";

interface Option {
  value: string;
  label: string;
}

export const currencyOptions: Option[] = [
  { value: "USD", label: "USD - US Dollar ($)" },
  { value: "EUR", label: "EUR - Euro (€)" },
  { value: "GBP", label: "GBP - British Pound (£)" },
  { value: "JPY", label: "JPY - Japanese Yen (¥)" },
  { value: "CAD", label: "CAD - Canadian Dollar (C$)" },
  { value: "AUD", label: "AUD - Australian Dollar (A$)" },
  { value: "CHF", label: "CHF - Swiss Franc" },
  { value: "CNY", label: "CNY - Chinese Yuan (¥)" },
  { value: "SEK", label: "SEK - Swedish Krona" },
  { value: "NZD", label: "NZD - New Zealand Dollar" },
  { value: "MXN", label: "MXN - Mexican Peso" },
  { value: "SGD", label: "SGD - Singapore Dollar" },
  { value: "HKD", label: "HKD - Hong Kong Dollar" },
  { value: "NOK", label: "NOK - Norwegian Krone" },
  { value: "TRY", label: "TRY - Turkish Lira" },
  { value: "RUB", label: "RUB - Russian Ruble" },
  { value: "INR", label: "INR - Indian Rupee (₹)" },
  { value: "KRW", label: "KRW - South Korean Won" },
  { value: "BRL", label: "BRL - Brazilian Real" },
  { value: "ZAR", label: "ZAR - South African Rand" },
  { value: "PLN", label: "PLN - Polish Zloty" },
  { value: "CZK", label: "CZK - Czech Koruna" },
  { value: "HUF", label: "HUF - Hungarian Forint" },
  { value: "ILS", label: "ILS - Israeli Shekel" },
  { value: "CLP", label: "CLP - Chilean Peso" },
  { value: "PHP", label: "PHP - Philippine Peso" },
  { value: "AED", label: "AED - UAE Dirham" },
  { value: "COP", label: "COP - Colombian Peso" },
  { value: "SAR", label: "SAR - Saudi Riyal" },
  { value: "MYR", label: "MYR - Malaysian Ringgit" },
  { value: "RON", label: "RON - Romanian Leu" },
  { value: "THB", label: "THB - Thai Baht" },
  { value: "EGP", label: "EGP - Egyptian Pound" },
  { value: "VND", label: "VND - Vietnamese Dong" },
  { value: "BGN", label: "BGN - Bulgarian Lev" },
  { value: "HRK", label: "HRK - Croatian Kuna" },
  { value: "ISK", label: "ISK - Icelandic Krona" },
  { value: "UYU", label: "UYU - Uruguayan Peso" },
  { value: "PEN", label: "PEN - Peruvian Sol" },
  { value: "QAR", label: "QAR - Qatari Riyal" },
  { value: "LKR", label: "LKR - Sri Lankan Rupee" },
  { value: "PKR", label: "PKR - Pakistani Rupee" },
  { value: "BDT", label: "BDT - Bangladeshi Taka" },
  { value: "NGN", label: "NGN - Nigerian Naira" },
  { value: "KES", label: "KES - Kenyan Shilling" },
  { value: "GHS", label: "GHS - Ghanaian Cedi" },
  { value: "MAD", label: "MAD - Moroccan Dirham" },
  { value: "TND", label: "TND - Tunisian Dinar" },
  { value: "UGX", label: "UGX - Ugandan Shilling" },
  { value: "XOF", label: "XOF - West African CFA Franc" },
  { value: "XAF", label: "XAF - Central African CFA Franc" },
  { value: "MMK", label: "MMK - Myanmar Kyat" },
];

interface CurrencySelectProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isRequired?: boolean;
  error?: string;
  className?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  menuPortalTarget?: HTMLElement | null;
  menuPosition?: "fixed" | "absolute";
  styles?: Record<string, any>;
}

export const CurrencySelect: React.FC<CurrencySelectProps> = ({
  value,
  onChange,
  placeholder = "Select currency",
  isRequired = false,
  error,
  className = "",
  isClearable = true,
  isDisabled = false,
  menuPortalTarget,
  menuPosition,
  styles,
}) => {
  return (
    <>
      <Select
        options={currencyOptions}
        value={currencyOptions.find((option) => option.value === value) || null}
        onChange={(option) => onChange(option?.value || "")}
        placeholder={placeholder}
        isClearable={isClearable}
        isDisabled={isDisabled}
        className={error ? `is-invalid ${className}` : className}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        styles={styles}
      />
      {error && <div className="text-danger mt-1">{error}</div>}
    </>
  );
};
